<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Schedule a game</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <b-field
        label="Tickets"
        :type="limitIsValid ? 'is-success' : 'is-danger'"
        :message="limitIsValid ? '' : 'Number of tickets must be divisible by 6'"
      >
        <b-input v-model.number="limit" type="number" min="6" step="6" placeholder="number of tickets" required></b-input>
      </b-field>

      <b-field label="Game Type">
        <GameTypeFields v-model="gameType" />
      </b-field>

      <b-field label="Schedule date and time">
        <b-datetimepicker
          v-model="time"
          :mobile-native="false"
          :timepicker="timepicker"
          placeholder="Select a date"
          icon="calendar-today"
        ></b-datetimepicker>
      </b-field>

      <b-field label="Price per ticket">
        <b-input v-model.number="per_ticket" type="number" min="0" placeholder="100"></b-input>
      </b-field>

      <b-field label="Commision per ticket">
        <b-input v-model.number="commission" type="number" min="0" placeholder="20"></b-input>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <button type="button" class="button is-primary" @click="submit()">Schedule</button>
    </footer>
  </div>
</template>

<script>
  import GameTypeFields from "./GameTypeFields.vue";
  import { defaultScheduleTime, enabledGameTypes } from "../constants/game";

  export default {
    name: "ScheduleAsk",
    components: { GameTypeFields },
    data() {
      return {
        limit: 600,
        time: defaultScheduleTime(),
        per_ticket: "",
        commission: "",
        gameType: {},
        timepicker: {
          incrementMinutes: 15,
          incrementHours: 1,
          hourFormat: "12"
        }
      };
    },
    computed: {
      // Tickets are sold in sheets of six, so the pool has to divide evenly.
      limitIsValid() {
        return !!this.limit && this.limit % 6 === 0;
      }
    },
    methods: {
      submit() {
        if (!this.limitIsValid) {
          return this.$buefy.dialog.alert({
            title: "Error!",
            message: "Number should be divisible of 6",
            type: "is-danger",
            hasIcon: true,
            icon: "close-circle",
            ariaRole: "alertdialog",
            ariaModal: true
          });
        }

        this.$emit("ScheduleGame", {
          limit: this.limit,
          per_ticket: this.per_ticket,
          commission: this.commission,
          time: this.time,
          gameType: enabledGameTypes(this.gameType)
        });
        this.$parent.close();
      }
    }
  };
</script>
